"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailsService = void 0;
class EmailsService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns any
     * @throws ApiError
     */
    findAll() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/emails',
        });
    }
    /**
     * @returns any The email was sent successfully.
     * @throws ApiError
     */
    send({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/emails/send',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.EmailsService = EmailsService;
